import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-minus\"><path fill-rule=\"evenodd\" d=\"M1.256 10.839h21.488c.17 0 .256.081.256.244v1.834c0 .163-.085.244-.256.244H1.256c-.17 0-.256-.081-.256-.244v-1.834c0-.163.085-.244.256-.244z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol